import store from 'store2';
import constants from './constants';

const shouldShowToast = () => {
  const val = store(constants.SURVEY_STATE_NAME);
  return (
    (val === constants.SURVEY_STATE_VALUE_ANSWERED ||
      val === constants.SURVEY_STATE_VALUE_DECLINED) === false
  );
};

export default shouldShowToast;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/shouldShowToast.js